import { render, staticRenderFns } from "./feyCourt.vue?vue&type=template&id=0d53f5a4&"
import script from "./feyCourt.vue?vue&type=script&lang=js&"
export * from "./feyCourt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports